import { render, staticRenderFns } from "./FIBTimePicker.vue?vue&type=template&id=96c20d86&scoped=true&"
import script from "./FIBTimePicker.vue?vue&type=script&lang=js&"
export * from "./FIBTimePicker.vue?vue&type=script&lang=js&"
import style0 from "./FIBTimePicker.vue?vue&type=style&index=0&id=96c20d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c20d86",
  null
  
)

export default component.exports